import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CardLayout from '@/layouts/CardLayout.vue';
import Background from '@/components/Background.vue';
import Next from '@/components/Next.vue';
import CounterButton from '@/components/CounterButton.vue';
import BeeInput from '@/components/BeeInput.vue';
import SpinnerHolder from '@/components/SpinnerHolder.vue';
import CommonHeader from '@/components/CommonHeader.vue';
import BeeCheckbox from '@/components/BeeCheckbox.vue';
import MiniCart from '@/components/MiniCart.vue';
import Item from '@/models/Item';
import Modal from '@/components/Modal.vue';
import Carousel from '@/components/Carousel.vue';
import { localizedProductPrice, localizedProductName, localizedIngredientName, localizedExtraIngredientName, localizedExtraIngredientPrice } from '../mixins/MenuLocalization';
import ItemIngredient from '../models/ItemIngredient';
import MenuService from '../services/MenuService';
import ItemExtraIngredient from '@/models/ItemExtraIngredient';
import { TypeOrder } from '@/store/state';
let Dish = class Dish extends Vue {
    constructor() {
        super(...arguments);
        this.product = null;
        this.category = null;
        this.subCategory = null;
        this.numberOfItems = 1;
        this.userCanOrder = this.$store.getters.canOrder;
        this.ingredients = [];
        this.ingredientsResult = '';
        this.details = '';
        this.nIngredient = [];
        this.changeNote = true;
        this.changeReq = true;
        this.showVideo = false;
        this.videoUrl = '';
        this.price = null;
    }
    loadCarousel(photosURL) {
        const items = photosURL.map(i => ({ url: i }));
        return items;
    }
    status(check, grupo, maxi, index2) {
        if (maxi !== 0) {
            if (check == true) {
                if (this.nIngredient[grupo] <= maxi) {
                    this.nIngredient[grupo]++;
                    this.ingredients[grupo].selected = true;
                }
                if (this.nIngredient[grupo] > maxi) {
                    this.ingredients[grupo].extraIngredients[index2].selected = false;
                    this.nIngredient[grupo]--;
                }
            }
            else {
                this.nIngredient[grupo]--;
                this.nIngredient[grupo] == 0 ? (this.ingredients[grupo].selected = false) : null;
            }
        }
        if (maxi == 0) {
            check ? this.nIngredient[grupo]++ : this.nIngredient[grupo]--;
            this.nIngredient[grupo] == 0
                ? (this.ingredients[grupo].selected = false)
                : (this.ingredients[grupo].selected = true);
        }
    }
    getProduct(productId) {
        const products = this.$store.getters.products;
        const product = products.find(p => p.id == productId && localizedProductPrice(p));
        return product || null;
    }
    getCategory(categoryId) {
        const categories = this.$store.getters.categories;
        const category = categories.find(c => c.id == categoryId);
        return category || null;
    }
    getSubCategory(subCategoryId) {
        const subCategories = this.$store.getters.subcategories;
        const subCategory = subCategories.find(c => c.id == subCategoryId);
        return subCategory || null;
    }
    getPrice() {
        let extra = 0;
        if (this.price) {
            this.ingredients.map(i => {
                i.extraIngredients.map(e => {
                    const extraPrice = localizedExtraIngredientPrice(e);
                    if (extraPrice) {
                        if (e.selected) {
                            extra += extraPrice.ammount;
                        }
                    }
                });
            });
            return this.numberOfItems * (this.price?.ammount + extra);
        }
    }
    addProductToOrder() {
        let error = 0;
        this.ingredients.forEach((ing, index) => {
            if (ing.required) {
                let aux = 0;
                ing.extraIngredients.forEach(extra => {
                    if (extra.selected)
                        aux++;
                });
                if (aux == 0) {
                    this.changeReq = false;
                    error += 1;
                }
                else if (ing.maxAmount != 0) {
                    if (this.nIngredient[index] > ing.maxAmount) {
                        error += 1;
                        this.changeNote = false;
                    }
                }
            }
        });
        if (this.product && error == 0) {
            const item = new Item();
            const price = localizedProductPrice(this.product);
            let priceIngredients = 0;
            item.id = this.product.id;
            item.name = this.product.name;
            if (this.category) {
                item.category = this.category.name;
            }
            if (this.subCategory) {
                item.subcategory = this.subCategory.name;
            }
            item.localizedName = localizedProductName(this.product);
            item.photoURL = this.product.photosURL[0];
            item.quantity = this.numberOfItems;
            item.details = this.details;
            if (price) {
                item.price = price;
            }
            item.type = 'PRODUCT';
            item.ingredients = this.ingredients.map(i => {
                const itemIngredient = new ItemIngredient();
                itemIngredient.id = i.id;
                itemIngredient.selected = i.selected;
                itemIngredient.localizedNames = localizedIngredientName(i);
                itemIngredient.extraIngredients = i.extraIngredients.map(e => {
                    const itemExtra = new ItemExtraIngredient();
                    itemExtra.id = e.id;
                    itemExtra.selected = e.selected;
                    itemExtra.localizedNames = localizedExtraIngredientName(e);
                    const extraPrice = localizedExtraIngredientPrice(e);
                    if (extraPrice) {
                        itemExtra.price = extraPrice;
                        if (itemExtra.selected) {
                            priceIngredients += extraPrice.ammount;
                        }
                    }
                    return itemExtra;
                });
                return itemIngredient;
            });
            item.priceIngredients = priceIngredients;
            this.$store.dispatch('addItemToOrder', item);
            this.nIngredient = this.nIngredient.fill(0);
            this.ingredients.forEach(ing => {
                ing.selected = false;
                ing.extraIngredients.forEach(extra => {
                    extra.selected = false;
                });
            });
            this.$analytics.logEvent('add_to_cart', {
                id: this.product.id,
                value: price?.ammount,
                items: [
                    {
                        item_id: this.product.id,
                        item_name: this.product.name,
                        affiliation: this.$store.state.typeOrder,
                        item_brand: this.$store.state.menu.name,
                        item_category: this.category?.name,
                        item_category2: this.subCategory?.name
                    }
                ],
                currency: price?.currency
            });
            this.$router.push('/menu');
        }
    }
    goBack() {
        history.back();
    }
    get style() {
        if (this.$store.state.customLogoURL) {
            return `background-image: url('${this.$store.state.customLogoURL}')`;
        }
        return '';
    }
    created() {
        document.oncontextmenu = function () {
            return false;
        };
        this.ingredients = this.$store.getters.ingredients(this.$route.params.productId);
        this.nIngredient = Array(this.ingredients.length).fill(0);
        this.product = this.getProduct(this.$route.params.productId);
        if (this.product) {
            this.category = this.getCategory(this.product.categoryId);
            if (this.product.subCategoryId) {
                this.subCategory = this.getSubCategory(this.product.subCategoryId);
            }
            MenuService.addViewToProduct(this.product.id, this.$store.state.typeOrder);
            if (this.product.video)
                this.videoUrl = this.product.video.replace('watch?v=', 'embed/');
            this.price = localizedProductPrice(this.product);
            this.$analytics.logEvent('view_item', {
                id: this.product.id,
                value: this.price?.ammount,
                items: [
                    {
                        item_id: this.product.id,
                        item_name: this.product.name,
                        affiliation: this.$store.state.typeOrder,
                        item_brand: this.$store.state.menu.name,
                        item_category: this.category?.name,
                        item_category2: this.subCategory?.name
                    }
                ],
                currency: this.price?.currency
            });
        }
        if (this.$store.state.typeOrder != TypeOrder.LOCAL) {
            this.userCanOrder = true;
        }
    }
};
Dish = __decorate([
    Component({
        components: {
            Background,
            CardLayout,
            CommonHeader,
            Next,
            CounterButton,
            BeeInput,
            SpinnerHolder,
            BeeCheckbox,
            Modal,
            MiniCart,
            Carousel
        }
    })
], Dish);
export default Dish;
